import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$f75e from '/var/www/deployer/production/nuxt-portal/releases/166/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as ipxRuntime$b842 from '/var/www/deployer/production/nuxt-portal/releases/166/node_modules/@nuxt/image/dist/runtime/providers/ipx.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "listing43": {
      "modifiers": {
        "format": "webp",
        "width": 480,
        "height": 320
      }
    },
    "newsThumb": {
      "modifiers": {
        "format": "webp",
        "width": 373,
        "height": 210
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "media.ucsc.eu",
    "media.getrix.it",
    "media.ucsc-getrix.it",
    "mediaserver.getrix.it",
    "res.getrix.it",
    "www.unicreditsubitocasa.it",
    "staging.unicreditsubitocasa.it",
    "www.unicreditres.it",
    "staging.unicreditres.it"
  ],
  "alias": {
    "/mediaucsc": "https://media.ucsc.eu",
    "/media": "http://media.getrix.it",
    "/ms": "https://mediaserver.getrix.it",
    "/res": "https://res.getrix.it",
    "/newsimg": "https://www.unicreditres.it"
  }
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$f75e, defaults: {} },
  ['ipx']: { provider: ipxRuntime$b842, defaults: {"baseURL":"https://ent.a-cdn.net/ucsc/_ipx","modifiers":{"format":"webp"}} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
